/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eg_Shootshareconnect_Or_JaneInputs */

const en_eg_shootshareconnect_or_jane = /** @type {(inputs: Eg_Shootshareconnect_Or_JaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. shootshareconnect or janesmithphotography`)
};

const es_eg_shootshareconnect_or_jane = /** @type {(inputs: Eg_Shootshareconnect_Or_JaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. shootshareconnect o mariaperezfotografia`)
};

const fr_eg_shootshareconnect_or_jane = /** @type {(inputs: Eg_Shootshareconnect_Or_JaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. shootshareconnect ou janesmithphotography`)
};

const de_eg_shootshareconnect_or_jane = /** @type {(inputs: Eg_Shootshareconnect_Or_JaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. shootshareconnect oder maxmustermannfotografie`)
};

const ja_eg_shootshareconnect_or_jane = /** @type {(inputs: Eg_Shootshareconnect_Or_JaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: shootshareconnect または janesmithphotography`)
};

const zh_eg_shootshareconnect_or_jane = /** @type {(inputs: Eg_Shootshareconnect_Or_JaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：shootshareconnect 或 janesmithphotography`)
};

const ar_eg_shootshareconnect_or_jane = /** @type {(inputs: Eg_Shootshareconnect_Or_JaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مثال: shootshareconnect أو janesmithphotography`)
};

const id_eg_shootshareconnect_or_jane = /** @type {(inputs: Eg_Shootshareconnect_Or_JaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. shootshareconnect atau janesmithphotography`)
};

const it_eg_shootshareconnect_or_jane = /** @type {(inputs: Eg_Shootshareconnect_Or_JaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. shootshareconnect o mariorossifotografia`)
};

const ru_eg_shootshareconnect_or_jane = /** @type {(inputs: Eg_Shootshareconnect_Or_JaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например, shootshareconnect или ivanivanov`)
};

const pt_eg_shootshareconnect_or_jane = /** @type {(inputs: Eg_Shootshareconnect_Or_JaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. shootshareconnect ou mariasilvafotografia`)
};

const ko_eg_shootshareconnect_or_jane = /** @type {(inputs: Eg_Shootshareconnect_Or_JaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예: shootshareconnect 또는 honggildong`)
};

/**
* | output |
* | --- |
* | "e.g. shootshareconnect or janesmithphotography" |
*
* @param {Eg_Shootshareconnect_Or_JaneInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const eg_shootshareconnect_or_jane = /** @type {((inputs?: Eg_Shootshareconnect_Or_JaneInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eg_Shootshareconnect_Or_JaneInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eg_shootshareconnect_or_jane(inputs)
	if (locale === "es") return es_eg_shootshareconnect_or_jane(inputs)
	if (locale === "fr") return fr_eg_shootshareconnect_or_jane(inputs)
	if (locale === "de") return de_eg_shootshareconnect_or_jane(inputs)
	if (locale === "ja") return ja_eg_shootshareconnect_or_jane(inputs)
	if (locale === "zh") return zh_eg_shootshareconnect_or_jane(inputs)
	if (locale === "ar") return ar_eg_shootshareconnect_or_jane(inputs)
	if (locale === "id") return id_eg_shootshareconnect_or_jane(inputs)
	if (locale === "it") return it_eg_shootshareconnect_or_jane(inputs)
	if (locale === "ru") return ru_eg_shootshareconnect_or_jane(inputs)
	if (locale === "pt") return pt_eg_shootshareconnect_or_jane(inputs)
	return ko_eg_shootshareconnect_or_jane(inputs)
});